import { SweetAlert2Module } from '@toverux/ngx-sweetalert2';
import { DirectivesModule } from './../../common/directives/directives.module';
import { HttpClientModule } from "@angular/common/http";
import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { ListComponent } from "./list/list.component";
import { DetailComponent } from "./detail/detail.component";
import { EditComponent } from "./edit/edit.component";
import { CreateComponent } from "./create/create.component";
import { LocationRoutingModule } from "./location-routing.module";
import { LocationComponent } from "./location.component";
import { LocationService } from "../../api/location/location.service";
import { ApiUrl } from "../../api/api-url.service";
import { FormsModule } from "@angular/forms";

@NgModule({
  imports: [
    CommonModule,
    LocationRoutingModule,
    HttpClientModule,
    FormsModule,
    DirectivesModule,
    SweetAlert2Module,
  ],
  providers: [LocationService, ApiUrl],
  declarations: [
    ListComponent,
    DetailComponent,
    EditComponent,
    CreateComponent,
    LocationComponent
  ]
})
export class LocationModule {}
